import { withInstall } from '@zoryn/utils'
import Empty from './src/empty.vue'

import type { SFCWithInstall } from '@zoryn/utils'

export const ZEmpty: SFCWithInstall<typeof Empty> = withInstall(Empty)
export default ZEmpty

export * from './src/empty'
export type { EmptyInstance } from './src/instance'
